export interface FilmFact {
  label: string;
  value: string;
  icon: string;
}

export const filmFacts: FilmFact[] = [
  { label: '上映日期', value: '1993 年 4 月 17 日（香港）', icon: 'ri-calendar-line' },
  { label: '导演', value: '张肇麟', icon: 'ri-movie-2-line' },
  { label: '编剧', value: '张肇麟 · 谷德昭', icon: 'ri-quill-pen-line' },
  { label: '监制', value: '高志森', icon: 'ri-user-star-line' },
  { label: '出品公司', value: '高志森影业有限公司', icon: 'ri-building-2-line' },
  { label: '影片分级', value: '第三级（香港 Ⅲ 级片）', icon: 'ri-shield-star-line' },
  { label: '影片类型', value: '剧情 / 爱情', icon: 'ri-film-line' },
  { label: '语言', value: '粤语', icon: 'ri-translate-2' },
];

export const filmSummary =
  '《蜜桃成熟时》（英文名 Crazy Love）是 1993 年在香港上映的都市爱情剧情片，由张肇麟执导、高志森监制，李丽珍领衔主演。影片讲述富家女阿珍在一个暑假里出走、受挫、远行与成长的故事，是 1990 年代香港同类型作品中颇具话题性的一部。';